export const MESSAGE_EVENTS = {
  NEW_MESSAGE: 'message:new',
  MESSAGE_READ: 'message:read',
  MESSAGE_DELETED: 'message:deleted',
  MESSAGE_EDITED: 'message:edited',
  TYPING_START: 'message:typing_start',
  TYPING_STOP: 'message:typing_stop',
  GROUP_CREATED: 'group:created',
  GROUP_UPDATED: 'group:updated',
  GROUP_MEMBER_ADDED: 'group:member_added',
  GROUP_MEMBER_REMOVED: 'group:member_removed',
  GROUP_MEMBER_LEFT: 'group:member_left',
} as const;

export type MessageEventName = (typeof MESSAGE_EVENTS)[keyof typeof MESSAGE_EVENTS];
